const styles = `:host {
  --goto-icon-color: var(--goto-icon-04);
  --chameleon-select-height: 36px;
  --base-height-multiplier: var(--chameleon-select-height);
  --type-ramp-base-line-height: 36px;
  background: transparent;
  position: relative;
  color: var(--goto-text-01);
  width: 250px;
  min-width: unset;
  border: none;
  box-shadow: none;
  display: block;
  align-items: center;
}
:host .label {
  color: var(--goto-text-01);
  font: var(--goto-caption-default-02);
  display: inline-flex;
  margin-bottom: 2px;
}
:host .control {
  --goto-icon-size: 20px;
  background-color: var(--goto-ui-01);
  border-radius: 4px !important;
  border: 1px solid var(--goto-border);
  height: var(--chameleon-select-height);
  box-sizing: border-box;
  padding: 0 6px 0 12px;
}
:host .start {
  margin: -4px 16px 0 -2px;
}
:host .indicator {
  margin-inline-start: 0.4em;
  width: 24px;
  height: 24px;
  margin-top: 5px;
}
:host .listbox {
  display: flex;
  visibility: visible;
  opacity: 1;
  font-size: 14px;
  line-height: 36px;
  max-height: var(--max-height);
  background: var(--goto-ui-01);
  border-radius: 4px !important;
  border: 1px solid var(--goto-border) !important;
  box-shadow: var(--goto-elevation-300);
  padding: 0;
}
:host .listbox[hidden] {
  display: none;
  visibility: hidden;
  opacity: 0;
}
:host .selected-value {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
:host [variant=button-text-small] {
  margin-right: var(--goto-spacing-01);
}

:host(:not([disabled]):hover),
:host([disabled]:hover) {
  background: transparent;
}

:host(:not([disabled])) .control:hover {
  color: var(--goto-text-02);
  border-color: var(--goto-border);
  background-color: var(--goto-hover-secondary);
}
:host(:not([disabled])) .control:active {
  color: var(--goto-text-02);
  border-color: var(--goto-border);
  background-color: var(--goto-pressed-secondary);
}

:host(:not([disabled])[open]) .control {
  color: var(--goto-text-02);
  border-color: var(--goto-border);
  background-color: var(--goto-pressed-secondary);
}

:host([size=small]) {
  --chameleon-select-height: 30px;
  --type-ramp-base-line-height: 24px;
}
:host([size=small]) .control {
  font-size: 14px;
}
:host([size=small]) .indicator {
  height: 18px;
  margin-top: 0;
}
:host([size=small]) .start {
  margin: -6px 16px 0 -2px;
}
:host([size=small]) .listbox {
  font-size: 12px;
  line-height: 24px;
}

:host([open]) .indicator {
  transform: rotateX(180deg);
  margin-top: -2px;
}
:host([open]) ::slotted([aria-selected=true][role=option]:hover) {
  --goto-icon-color: var(--goto-text-04);
}

:host([size=large]) {
  --chameleon-select-height: 42px;
}

:host([size=xlarge]) {
  --chameleon-select-height: 48px;
}

:host([open][position=below]) .listbox {
  top: var(--chameleon-select-height);
}

:host([open][position=above]) .listbox {
  bottom: var(--chameleon-select-height);
}

:host(:not([inline])[open][helper-text]:not([helper-text=""])[position=above]) .listbox {
  bottom: calc(var(--chameleon-select-height) + var(--goto-spacing-04));
}

:host(:not([inline])[open][label]:not([label=""])[position=below]) .listbox {
  top: calc(var(--chameleon-select-height) + var(--goto-spacing-04));
}

:host(:focus) ::slotted([aria-selected=true][role=option]:not([disabled])) {
  --goto-icon-color: var(--goto-text-04);
  color: var(--goto-text-04);
  background-color: var(--goto-interactive-01);
}

:host(:not([disabled]):focus-visible) .control {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight-small);
}

:host(:not([disabled])[open]:focus-visible) .control {
  border-color: none;
  box-shadow: none;
}

:host([disabled]) {
  opacity: unset;
}
:host([disabled]) .control {
  --goto-icon-color: var(--goto-disabled-04);
  color: var(--goto-text-03);
}

:host(:not([disabled])[success]) .control,
:host(:not([disabled])[success]) .control:hover {
  border-color: var(--goto-success-01);
}

:host(:not([disabled])[success]:focus-visible) .control {
  border-color: var(--goto-success-01);
  box-shadow: var(--goto-highlight-success-small);
}

:host(:not([disabled])[error]) .control,
:host(:not([disabled])[error]) .control:hover {
  border-color: var(--goto-danger-01);
}

:host(:not([disabled])[error]:focus-visible) .control {
  border-color: var(--goto-danger-01);
  box-shadow: var(--goto-highlight-error-small);
}

:host([inline]) {
  --chameleon-select-height: 20px;
  display: inline-flex;
  min-width: auto;
  width: auto;
}
:host([inline]) .control {
  border: 1px solid transparent;
  border-radius: 12px !important;
  color: var(--goto-text-01);
  font: var(--goto-caption-default-02);
  padding: 0 8px;
  width: auto;
}
:host([inline]) .indicator {
  align-items: center;
  display: inline-flex;
  margin: 0 0 0 6px;
}
:host([inline]) .listbox {
  max-width: 250px;
  width: max-content;
}
:host([inline]) [variant=caption-default-01] {
  display: none;
}

:host([inline]:hover) .control {
  background-color: var(--goto-hover-secondary);
  border-color: var(--goto-field-01);
  color: var(--goto-text-01);
}

:host([inline]:active) .control {
  background-color: var(--goto-pressed-secondary);
  border-color: var(--goto-field-01);
  color: var(--goto-text-01);
}

:host([inline]:focus-visible) .control {
  border-color: var(--goto-focus);
  box-shadow: var(--goto-highlight-small);
}

:host(:focus-visible) {
  box-shadow: none;
}

:host(:focus-visible) ::slotted([aria-selected=true][role=option]:not([disabled])) {
  box-shadow: none;
  border-color: var(--goto-interactive-01);
}

:host(:not([disabled])[open]) .control {
  background-color: var(--goto-pressed-secondary);
  color: var(--goto-text-01);
}

:host([disabled]) .control,
:host([disabled]:hover) .control {
  background-color: var(--goto-field-04);
  border-color: var(--goto-field-01);
  color: var(--goto-text-03);
}

:host([inline][disabled]) .control,
:host([inline][disabled]:hover) .control {
  background-color: var(--goto-hover-secondary);
}

:host([fullwidth]) {
  width: 100%;
}
:host([fullwidth]) .control {
  width: 100%;
}`; export default styles;